import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";

import BackgroundColor from "../../../assets/newsletter/background_color.webp";
import BackgroundHaze from "../../../assets/newsletter/BackgroundHaze.webp";
import GradientBackground from "../../../assets/newsletter/gradient_background.webp";
import SpaceGas from "../../../assets/newsletter/SpaceGas.webp";
import Stars from "../../../assets/newsletter/Stars.webp";
import Stars1 from "../../../assets/newsletter/Stars-1.webp";
import Stars2 from "../../../assets/newsletter/Stars-2.webp";
import Asteroid1 from "../../../assets/newsletter/Asteroid1.webp";
import Asteroid2 from "../../../assets/newsletter/Asteroid2.webp";
import Asteroid3 from "../../../assets/newsletter/Asteroid3.webp";
import Asteroid4 from "../../../assets/newsletter/Asteroid4.webp";
import Asteroid5 from "../../../assets/newsletter/Asteroid5.webp";
import NewsPaper from "../../../assets/newsletter/paper.webp";
import BonkHead from "../../../assets/newsletter/BonkHead.webp";

import { getLayerSpeed, getLayerOffset } from "./utilz/newsletterLayerSpeed";
import { LayersProps } from "../../../models/newsletter.model";

export const NewsLetterLayers: React.FC<LayersProps> = ({ offset }) => (
	<>
		{/* Background trio */}
		<ParallaxLayer
			key={`NewsLetter-background-${offset}`}
			offset={getLayerOffset("background", offset)}
			speed={getLayerSpeed("background")}
			style={{ zIndex: 1, overflow: "hidden" }}
		>
			<div className="newsletter-background-color">
				<img
					src={BackgroundColor}
					alt="Newsletter Background Color"
				/>
			</div>
			<div className="newsletter-background-haze">
				<img
					src={BackgroundHaze}
					alt="Newsletter Background Haze"
				/>
			</div>
			<div className="newsletter-gradient-background">
				<img
					src={GradientBackground}
					alt="Newsletter Gradient Background"
				/>
			</div>
		</ParallaxLayer>

		{/* Space gas */}
		<ParallaxLayer
			key={`NewsLetter-spaceGas-${offset}`}
			offset={getLayerOffset("spaceGas", offset)}
			speed={getLayerSpeed("spaceGas")}
			style={{ zIndex: 2, overflow: "hidden" }}
		>
			<div className="newsletter-space-gas">
				<img
					src={SpaceGas}
					alt="Newsletter Space Gas"
				/>
			</div>
		</ParallaxLayer>

		{/* Stars */}
		<ParallaxLayer
			key={`NewsLetter-stars-${offset}`}
			offset={getLayerOffset("stars", offset)}
			speed={getLayerSpeed("stars")}
			style={{ zIndex: 3, overflow: "hidden" }}
		>
			{[Stars, Stars1, Stars2].map((img, i) => (
				<div
					className="newsletter-stars"
					key={i}
				>
					<img
						src={img}
						alt={`Newsletter Stars ${i + 1}`}
					/>
				</div>
			))}
		</ParallaxLayer>

		{/* Asteroids cluster */}
		<ParallaxLayer
			key={`NewsLetter-asteroids-${offset}`}
			offset={getLayerOffset("asteroids", offset)}
			speed={getLayerSpeed("asteroids")}
			style={{ zIndex: 4, overflow: "hidden" }}
		>
			{[Asteroid1, Asteroid2, Asteroid3, Asteroid4].map((img, i) => (
				<div
					className={`newsletter-asteroids newsletter-asteroids-${i + 1}`}
					key={i}
				>
					<img
						src={img}
						alt={`Newsletter Asteroid ${i + 1}`}
					/>
				</div>
			))}
		</ParallaxLayer>
		<ParallaxLayer
			key={`NewsLetter-asteroids2-${offset}`}
			offset={getLayerOffset("asteroids2", offset)}
			speed={getLayerSpeed("asteroids2")}
			style={{ zIndex: 4, overflow: "hidden" }}
		>
			<div className="newsletter-asteroids newsletter-asteroids-5">
				<img
					src={Asteroid5}
					alt="Newsletter Asteroid 5"
				/>
			</div>
		</ParallaxLayer>

		{/* Paper */}
		<ParallaxLayer
			key={`NewsLetter-paper-${offset}`}
			offset={getLayerOffset("paper", offset)}
			speed={getLayerSpeed("paper")}
			style={{ zIndex: 5, overflow: "hidden" }}
		>
			<div className="newsletter-paper">
				<img
					src={NewsPaper}
					alt="Newsletter Paper"
				/>
			</div>
		</ParallaxLayer>

		{/* Bonk head (static) */}
		<ParallaxLayer
			key={`NewsLetter-bonkhead-${offset}`}
			offset={0}
			speed={0}
			style={{ zIndex: 6, overflow: "hidden" }}
		>
			<div className="newsletter-bonkhead">
				<img
					src={BonkHead}
					alt="Newsletter Bonk Head"
				/>
			</div>
		</ParallaxLayer>
	</>
);
